var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},[_vm._l((_vm.shareList),function(item,key){return [_c('button',{key:key,attrs:{"type":"button","title":item.title},on:{"click":item.shareFunction}},[_c(item.components,{tag:"component"})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }